import { Controller } from "@hotwired/stimulus";
import $ from "jquery";

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static values = {
        token: String,
    };

    connect() {
        const $passwordInput = $('#lawyer_password_password');
        const $passwordForm = $('[name="lawyer_password"]');
        const $passwordSubmit = $('.password-submit');
        let isValid = true;

        $passwordInput.on('focus', function() {
            $('#password-requirements').show();
        });

        $passwordInput.keyup(function() {
            isValid = true;
            const $length = $('.password-length');
            const $number = $('.password-number');
            const $char = $('#password-special-char');
            const $letter = $('#password-letter');

            const lowerCaseLetters = /[a-zA-Z]/g;
            const numbers = /[0-9]/g;
            const specialChar = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/g;

            // Validate length
            if ($passwordInput.val().length >= 8) {
                $length.removeClass('text-danger text-muted');
                $length.addClass('text-success');
            } else {
                $length.removeClass('text-success text-muted');
                $length.addClass('text-danger');
                isValid = false;
            }

            // Validate lowercase letters
            if ($passwordInput.val().match(lowerCaseLetters)) {
                $letter.removeClass('text-danger text-muted');
                $letter.addClass('text-success');
            } else {
                $letter.removeClass('text-success text-muted');
                $letter.addClass('text-danger');
                isValid = false;
            }

            // Validate numbers
            if ($passwordInput.val().match(numbers)) {
                $number.removeClass('text-danger text-muted');
                $number.addClass('text-success');
            } else {
                $number.removeClass('text-success text-muted');
                $number.addClass('text-danger');
                isValid = false;
            }

            // Validate special char
            if ($passwordInput.val().match(specialChar)) {
                $char.removeClass('text-danger text-muted');
                $char.addClass('text-success');
            } else {
                $char.removeClass('text-success text-muted');
                $char.addClass('text-danger');
                isValid = false;
            }

            if (isValid) {
                $passwordSubmit.attr('disabled', 'none');
                $passwordSubmit.removeAttr('disabled');
            } else {
                $passwordSubmit.attr('disabled', 'disabled');
            }
        });

        let contactExists = false;
        let contactCheckTimeout = null;
        let submitAttempted = false;

        const checkContactExistsAndMaybeSubmit = () => {
            $.post(routes['app_freetrial_contactexists'], { token: this.tokenValue })
                .done(function(response) {
                    contactExists = response.exists === true;
                    if (contactExists && submitAttempted) {
                        hidePreloader();
                        $passwordForm.off('submit');
                        $passwordForm.submit();
                    } else if (submitAttempted) {
                        contactCheckTimeout = setTimeout(checkContactExistsAndMaybeSubmit, 5000);
                    }
                })
                .fail(function() {
                    contactExists = false;
                    if (submitAttempted) {
                        contactCheckTimeout = setTimeout(checkContactExistsAndMaybeSubmit, 5000);
                    }
                });
        }

        $passwordForm.on('submit', function(event) {
            event.preventDefault();
            clearTimeout(contactCheckTimeout);

            if (!isValid) {
                return;
            }

            showPreloader();
            submitAttempted = true;
            checkContactExistsAndMaybeSubmit();
        });
    }
}

